const type = 'standard'
const path = '/standard/html-node/'
const name = 'index.js'

export { type, path, name }
